import {
  useV2ListQuestionsForQuestionnaireQuery,
  useV2ListQuestionnaireLookupsForQuestionnaireQuery,
} from "@generated";
import type { Operand } from "../types";

export const useCalculationOperands = (questionnaireId: string) => {
  const qid = Number(questionnaireId);
  const { data: qData } = useV2ListQuestionsForQuestionnaireQuery(
    { questionnaireId: qid, filter: { active: true }, page: { size: 500 } },
    { refetchOnMountOrArgChange: true }
  );
  const { data: lData } = useV2ListQuestionnaireLookupsForQuestionnaireQuery(
    { questionnaireId: qid, filter: { active: true }, page: { size: 500 } },
    { refetchOnMountOrArgChange: true }
  );

  const questions: Operand[] = (qData?.data ?? [])
    .filter((q: any) => q.attributes?.["value-type"] === "number")
    .map((q: any) => ({
      slug: q.attributes?.slug ?? "",
      name: q.attributes?.name ?? "",
    }))
    .filter((o: Operand) => o.slug !== "");

  const lookups: Operand[] = (lData?.data ?? [])
    .filter((l: any) => l.attributes?.["value-type"] === "number")
    .map((l: any) => ({
      slug: l.attributes?.slug ?? "",
      name: l.attributes?.name ?? "",
    }))
    .filter((o: Operand) => o.slug !== "");

  return { questions, lookups };
};

export default useCalculationOperands;
